// extracted by mini-css-extract-plugin
module.exports = {"b13k5jd7":"b13k5jd7","w1ecn8j4":"w1ecn8j4"};